var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5C15.8075 5 17.2727 6.49728 17.2727 8.34426C17.2727 9.49211 16.5294 10.5784 15.0909 11.6982L15.0909 11.8974L24.1658 16.0223C25.2828 16.5301 26 17.6439 26 18.8709C26 20.5991 24.5991 22 22.8709 22H5.12907C3.40093 22 2 20.5991 2 18.8709C2 17.6439 2.71719 16.5301 3.83425 16.0223L12.9091 11.8974V11.6981C12.9091 11.0022 13.2271 10.3463 13.7688 9.9246C14.6598 9.23106 15.0909 8.65385 15.0909 8.34426C15.0909 7.7286 14.6025 7.22951 14 7.22951C13.3975 7.22951 12.9091 7.7286 12.9091 8.34426C12.9091 8.95992 12.4207 9.45902 11.8182 9.45902C11.2157 9.45902 10.7273 8.95992 10.7273 8.34426C10.7273 6.49728 12.1925 5 14 5ZM4.66186 17.8431L14 13.5985L23.3381 17.8431C23.7412 18.0263 24 18.4282 24 18.8709C24 19.4945 23.4945 20 22.8709 20H5.12907C4.5055 20 4 19.4945 4 18.8709C4 18.4282 4.25879 18.0263 4.66186 17.8431Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerOutline);
export default __webpack_public_path__ + "static/media/hanger_outline.3732d60e26649eb42bf53b73c60bc0aa.svg";
export { ForwardRef as ReactComponent };